import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type {
  ActivePurchasedServicesListParams,
  ActivePurchasedServicesListResponseData,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const ACTIVE_PURCHASED_SERVICES_LIST_QUERY_KEY =
  'active_purchased_services_list';

export const useActivePurchasedServicesListQuery = (
  params: ActivePurchasedServicesListParams,
) =>
  useQuery({
    queryKey: [
      ACTIVE_PURCHASED_SERVICES_LIST_QUERY_KEY,
      params.url,
      params.queryParams,
    ],
    queryFn: () =>
      HttpClient.request<ActivePurchasedServicesListResponseData>({
        method: 'GET',
        url: params.url,
        params: params.queryParams,
      }),
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    retry: false,
  });
